<div class="entry">
    <span class="name">{{ 'property.' + name|translate }}</span>
    @if (value && typeof value === 'string') {
        <span class="value">{{ value }}</span>
    } @else if (value && Array.isArray(value)) {
        @for (v of value; track v; let last = $last) {
            <span class="value">{{ v }}</span>
            @if (!last) {
                <span>, </span>
            }
        }
    }
</div>